import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import GoogleImg from "../img/google.png";
import {
  loginFailure,
  loginStart,
  loginSuccess,
  RegisterFailure,
  RegisterStart,
  RegisterSuccess,
} from "../redux/userSlice";
import { useNavigate } from "react-router-dom";
import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { publicRequest } from "../requestMethods";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 56px);
  color: ${({ theme }) => theme.text};
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.bgLighter};
  padding: 20px 50px;
  border: 2px solid ${({ theme }) => theme.soft};
  gap: 10px;
  position: relative;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
`;
const SubTitle = styled.h2`
  font-size: 20px;
  @media only screen and (max-width: 767px) {
    text-align: center;
    font-size: 16px;
  }
`;
const Input = styled.input`
  border: 3px solid ${({ theme }) => theme.soft};
  border-radius: 3px;
  background-color: transparent;
  outline: none;
  padding: 10px;
  width: 100%;
  color: ${({ theme }) => theme.text};
`;
const Button = styled.button`
  border: none;
  color: ${({ theme }) => theme.textSoft};
  background-color: ${({ theme }) => theme.soft};
  cursor: pointer;
  padding: 10px 20px;
  border: none;
  align-items: center;
  display: flex;
  gap: 10px;
`;

const More = styled.div`
  display: flex;
  margin-top: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.textSoft};
`;

const Links = styled.div`
  margin-left: 50px;
`;
const Link = styled.span`
  margin-left: 30px;
`;

const GoogleIc = styled.img`
  width: 25px;
  height: 25px;
`;
const Error = styled.span`
  color: red;
  font-size: 12px;
`;

const Signin = () => {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(loginStart());
    try {
      const res = await publicRequest.post("/auth/signin", { name, password });
      dispatch(loginSuccess(res.data));
      navigate("/");
      window.location.reload();
    } catch (err) {
      dispatch(loginFailure(err));
      setErrorMessage(err.response.data.message);
    }
  };

  const signInWithGoogle = async () => {
    dispatch(loginStart());
    signInWithPopup(auth, provider)
      .then((result) => {
        publicRequest
          .post("/auth/google", {
            name: result.user.displayName,
            email: result.user.email,
            img: result.user.photoURL,
          })

          .then((res) => {
            dispatch(loginSuccess(res.data));
            navigate("/");
            window.location.reload();
          })
          .catch((error) => {
            dispatch(loginFailure());
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    dispatch(RegisterStart());
    try {
      const res = await publicRequest.post(`/auth/signup`, {
        name,
        email,
        password,
      });
      dispatch(RegisterSuccess(res.data));
      navigate("/");
    } catch (err) {
      dispatch(RegisterFailure());
    }
  };
  return (
    <Container>
      <Wrapper>
        <Title>MoudTube</Title>
        <SubTitle>Continue with MoudTube</SubTitle>
        <Input
          placeholder="username"
          onChange={(e) => setName(e.target.value)}
        />
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <RemoveRedEyeIcon
          style={{
            cursor: "pointer",
            position: "absolute",
            top: 153,
            right: 50,
          }}
          onClick={() => setShowPassword(!showPassword)}
        />
        <Error>{errorMessage}</Error>
        <Button onClick={handleLogin}>SignIn</Button>
        <Title>Or</Title>
        <Button onClick={signInWithGoogle}>
          <GoogleIc src={GoogleImg} alt="googleIcon" />
          Signin With Google
        </Button>
        <Title>Or</Title>

        <Input
          placeholder="username"
          onChange={(e) => setName(e.target.value)}
        />
        <Input
          type="email"
          placeholder="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <RemoveRedEyeIcon
          style={{
            cursor: "pointer",
            position: "absolute",
            bottom: 75,
            right: 50,
          }}
          onClick={() => setShowPassword(!showPassword)}
        />
        <Button onClick={handleRegister}>Register</Button>
      </Wrapper>
      <More>
        English(USA)
        <Links>
          <Link>Help</Link>
          <Link>Privacy</Link>
          <Link>Terms</Link>
        </Links>
      </More>
    </Container>
  );
};

export default Signin;
